<template>
    <div class="overflow-x-hidden">
        <section class="video-section grid flex flex-wrap justify-content-center align-items-center ">
            <div class="hero-section relative overflow-hidden shadow-4 col-12  ">
                <div v-if="!videoLoaded" class="loading-placeholder flex align-items-center justify-content-center">
                    <div class="loading-content text-center">
                        <i class="pi pi-spin pi-spinner text-4xl text-white mb-3"></i>
                        <p class="text-white">Loading...</p>
                    </div>
                </div>
                <video v-if="vedioUrl" autoplay muted loop playsinline preload="auto" class="hero-video  overflow-hidden"
                    :class="{ 'hidden': !videoLoaded }" @loadeddata="videoLoaded = true" @canplay="videoLoaded = true">
                    <source :src="vedioUrl" type="video/mp4" />
                </video>
                <div class="overlay-content text-center px-3">
                    <h1 class="LandingPage-Title text-white mb-3">
                        Where Learning Meets Paradise
                    </h1>
                    <p class="Paragraph-Medium md:px-8 mb-4 text-white">
                        A platform built in Sri Lanka to make learning simple, accessible, and inspiring for everyone.
                    </p>
                </div>
                <!-- <div class="text-center overlay-button">
                    <Button icon="pi pi-play" class="p-button-rounded p-button-outlined p-button-lg text-white" />
                </div> -->

            </div>
        </section>
    </div>
</template>
<script setup>
// import Button from 'primevue/button';
import { usePublicUrl } from "@/utils/getPublicUrl"
import { ref } from 'vue';
const vedioUrl = usePublicUrl("public/about.mp4");
const videoLoaded = ref(false);
</script>
<style scoped>
.loading-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: var(--gray-700);
    z-index: 2;
}

.hidden {
    display: none;
}

.hero-section {
    position: relative;
    overflow: hidden;
    height: 665px;
    margin: 0px;
    padding: 0px;
}

.hero-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000;
}

.overlay-content {
    position: absolute;
    top: 60%;
    left: 50%;
    /* transform: translate(10%, 40%); */
    max-width: 800px;
}

.overlay-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 800px;
}

/* Responsive Styles */
@media (max-width: 768px) {
    .hero-section {
        height: 400px;
    }
    .overlay-content {
        top: 30%;
        left: 0;
    }

    .overlay-content h1 {
        font-size: 1.5rem;
    }

    .overlay-content p {
        font-size: 0.9rem;
    }
}

</style>